export default __webpack_public_path__ + "static/media/WFHAM.797b6b51.svg";